export enum Routes {
  Auth = 'auth',
  Login = 'login',
  SignUp = 'sign-up',
  NotFound = '404',
  Chat = 'chat',
  ChatDetail = 'chat-detail',
  ChatsHistory = 'history',
}
